<div class="review" data-testid="dictionary-review-list">
  @for (group of groups(); track group.key) {
    @let count = group.proposals.length;
    <section class="review__group" data-testid="dictionary-review-group">
      <header class="review__group-header">
        <div class="review__group-title">
          <i class="pi pi-file review__group-icon" aria-hidden="true"></i>
          <div class="review__group-texts">
            <span class="review__group-name">
              {{ group.companyName ?? 'Documento de outra empresa' }}
            </span>
            <small class="review__group-meta">
              @if (group.appliedAt) {
                {{ group.appliedAt | vaultDateTime }} ·
              }
              {{ count }} {{ count === 1 ? 'mudança' : 'mudanças' }}
              @if (group.versionNumber) {
                · versão v{{ group.versionNumber }}
              }
            </small>
          </div>
        </div>
        <div class="review__group-actions">
          @if (group.companyId && group.extractionId) {
            <button
              type="button"
              class="review__link"
              data-testid="dictionary-review-open-document"
              (click)="openDocument(group)">
              <i class="pi pi-external-link" aria-hidden="true"></i>
              Abrir o documento
            </button>
          }
          @if (canManage()) {
            <app-button
              [label]="count === 1 ? 'Manter' : 'Manter todas'"
              [icon]="'pi pi-check'"
              [theme]="'white'"
              [size]="'small'"
              [type]="'button'"
              [disabled]="locked()"
              [isLoading]="busyGroupKey() === group.key"
              [loadingText]="'Mantendo...'"
              data-testid="dictionary-review-keep-all"
              (sendButtonClick)="keepAllRequested.emit(group)" />
          }
        </div>
      </header>
      <div class="review__rows" role="list">
        @for (proposal of group.proposals; track proposal.id) {
          <app-dictionary-review-row
            [proposal]="proposal"
            [expanded]="isExpanded(proposal.id)"
            [canManage]="canManage()"
            [busy]="busyProposalId() === proposal.id"
            [locked]="locked()"
            (toggleRequested)="toggle(proposal.id)"
            (keepRequested)="keepRequested.emit($event)"
            (revertRequested)="revertRequested.emit($event)" />
        }
      </div>
    </section>
  }
</div>
